import React, { useState, useRef, useEffect } from 'react';
import { Tooltips } from '../data/Tooltips';
import Definition from './Definition';

const Tooltip = ({children, className = ""}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({x: 0, y: 0});
  
  const openDefinition = (e) => {
    e.preventDefault();
    
    // get absolute position of the clicked event element to use in the Definition component
    const rect = e.target.getBoundingClientRect();
    setPosition({x: rect.left, y: rect.top, centerX: rect.left + (rect.width / 2), centerY: rect.top + (rect.height / 2), width: rect.width, height: rect.height});

    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }

  const closeDefinition = () => {    
    setIsOpen(false);
  }

  const handleOnBlur = () => {
    setIsOpen(false);
  }

  try {
    const tooltipContent = Tooltips.find((tooltip) => tooltip.id.toLowerCase() === children.toLowerCase());
    const randomString = Math.random().toString(36).substring(7);
    const labelledby = `${tooltipContent.id.toLowerCase().replace(/ /g, "-").replace(/[^a-zA-Z0-9]/g, "")}-${randomString}`;
    return (
      <>
        <a 
          onBlur={handleOnBlur} 
          onMouseDown={(e) => {e.preventDefault()}}
          href={`/${labelledby}`} 
          aria-label={`A button to open the definition of ${tooltipContent.id}`} 
          onClick={openDefinition} 
          className={`${className} tooltip underline decoration-[#f56060] decoration-1 underline-offset-[3px] font-medium`}
        >
          <span id={labelledby} className="not-italic pointer-events-none">{children}</span>
        </a>
        {
          isOpen && <Definition tooltipContent={tooltipContent} position={position} closeDefinition={closeDefinition}/>
        }
      </>
    );
  } catch (error) {
    console.log(`Error opening definition: ${error}`);
    return children;
  }
  
}

export default Tooltip;